import { FC } from 'react'
import DatePicker from 'react-datepicker'
import CustomSelect from '../../UI/CustomSelect/CustomSelect'
import CustomTextArea from '../../UI/CustomTextArea/CustomTextArea'
import styles from '../EditClaimCardMainInformation.module.css'
import { eventsList } from '../../../constants/constants'

interface EventItemProps {
  event: any
  index: number
  onEventNameChange: (index: number, name: string) => void
  onCommentChange: (index: number, comment: string) => void
  onTimeStartChange: (index: number, time: string) => void
  onTimeEndChange: (index: number, time: string) => void
  onDelete: (index: number) => void
}

export const EventItem: FC<EventItemProps> = ({
  event,
  index,
  onEventNameChange,
  onCommentChange,
  onTimeStartChange,
  onTimeEndChange,
  onDelete,
}) => {
  return (
    <div className={styles.eventsBlock}>
      <div className={styles.titleBlockEvent}>Мероприятие {index + 1}</div>
      <div className={styles.rightBlock}>
        <div
          style={{
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            gap: 8,
          }}
        >
          <CustomSelect
            name={`events-name-${index}`}
            options={eventsList}
            value={event?.name || ''}
            onChangeOption={(option) => onEventNameChange(index, option)}
          />
          <CustomTextArea
            value={event?.comment || ''}
            callbackHandler={(e) => onCommentChange(index, e.target.value)}
            placeholder='Комментарий'
            withoutFile
          />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <span style={{ fontSize: 14, color: '#666' }}>Время мероприятия</span>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <div style={{ flex: 1 }}>
                <DatePicker
                  showTimeSelect
                  showTimeSelectOnly
                  selected={
                    event?.timeStart
                      ? new Date(`2000-01-01T${event.timeStart}:00`)
                      : null
                  }
                  onChange={(time: Date | null) => {
                    if (time) {
                      const hours = time.getHours().toString().padStart(2, '0')
                      const minutes = time.getMinutes().toString().padStart(2, '0')
                      onTimeStartChange(index, `${hours}:${minutes}`)
                    } else {
                      onTimeStartChange(index, '')
                    }
                  }}
                  timeFormat='HH:mm'
                  dateFormat='HH:mm'
                  timeIntervals={15}
                  timeCaption='Начало'
                  placeholderText='Начало'
                  className={styles.timePickerInput}
                />
              </div>
              <span style={{ color: '#666' }}>—</span>
              <div style={{ flex: 1 }}>
                <DatePicker
                  showTimeSelect
                  showTimeSelectOnly
                  selected={
                    event?.timeEnd ? new Date(`2000-01-01T${event.timeEnd}:00`) : null
                  }
                  onChange={(time: Date | null) => {
                    if (time) {
                      const hours = time.getHours().toString().padStart(2, '0')
                      const minutes = time.getMinutes().toString().padStart(2, '0')
                      onTimeEndChange(index, `${hours}:${minutes}`)
                    } else {
                      onTimeEndChange(index, '')
                    }
                  }}
                  timeFormat='HH:mm'
                  dateFormat='HH:mm'
                  timeIntervals={15}
                  timeCaption='Конец'
                  placeholderText='Конец'
                  className={styles.timePickerInput}
                />
              </div>
            </div>
          </div>
          <div>
            <button className={styles.deleteBtn} type='button' onClick={() => onDelete(index)}>
              Удалить мероприятие
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
